"use strict";
/**
 * @ark/web-api 前端API客户端导出
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_LOCATION_HEADER = exports.getSiteLocation = exports.exponentialBackoff = exports.Retry = exports.isApiRetryable = exports.isApiNetworkError = exports.isApiBusinessError = exports.isApiServerError = exports.isApiError = exports.ApiError = exports.BaseApiClient = void 0;
var base_api_client_1 = require("./base-api-client");
// API 客户端基类
Object.defineProperty(exports, "BaseApiClient", { enumerable: true, get: function () { return base_api_client_1.BaseApiClient; } });
// 错误类
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return base_api_client_1.ApiError; } });
// 类型守卫
Object.defineProperty(exports, "isApiError", { enumerable: true, get: function () { return base_api_client_1.isApiError; } });
Object.defineProperty(exports, "isApiServerError", { enumerable: true, get: function () { return base_api_client_1.isApiServerError; } });
Object.defineProperty(exports, "isApiBusinessError", { enumerable: true, get: function () { return base_api_client_1.isApiBusinessError; } });
Object.defineProperty(exports, "isApiNetworkError", { enumerable: true, get: function () { return base_api_client_1.isApiNetworkError; } });
Object.defineProperty(exports, "isApiRetryable", { enumerable: true, get: function () { return base_api_client_1.isApiRetryable; } });
var retry_decorator_1 = require("./retry-decorator");
// 重试装饰器
Object.defineProperty(exports, "Retry", { enumerable: true, get: function () { return retry_decorator_1.Retry; } });
// 工具函数
Object.defineProperty(exports, "exponentialBackoff", { enumerable: true, get: function () { return retry_decorator_1.exponentialBackoff; } });
var site_location_1 = require("./site-location");
// 站点地区检测
Object.defineProperty(exports, "getSiteLocation", { enumerable: true, get: function () { return site_location_1.getSiteLocation; } });
Object.defineProperty(exports, "SITE_LOCATION_HEADER", { enumerable: true, get: function () { return site_location_1.SITE_LOCATION_HEADER; } });
